<template>
  <div style="background: #fff">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{
          getTitle('header.booking')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ getTitle('header.guide') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="guide-wrapper">
      <ul class="guide-list clearfix">
        <li v-for="item in guideList" :key="item.id">
          <div class="top">
            <div
              class="avatar"
              :style="{ backgroundImage: 'url(' + item.image + ')' }"
            ></div>
            <h3>{{ item.name }}</h3>
            <p
              class="ranking"
              :class="'ranking' + item.appraise"
              v-if="item.appraise"
            >
              {{ item.appraise_str }}
            </p>
            <p v-if="item.number">
              {{ getTitle('guide.no') }}：{{ item.number }}
            </p>
            <p class="level">
              <span v-if="item.level"
                >{{ getTitle('guide.level') }}：{{ item.level }}</span
              >
              <span v-if="item.language"
                >{{ getTitle('guide.language') }}：{{ item.language }}</span
              >
            </p>
            <p class="tel">{{ getTitle('guide.tel') }}：{{ item.tel }}</p>
          </div>
          <div class="bottom">
            <dl class="clearfix" v-if="item.introduction">
              <dt>{{ getTitle('guide.intro') }}：</dt>
              <dd>{{ item.introduction }}</dd>
            </dl>
            <dl class="clearfix" v-if="item.expenses">
              <dt>{{ getTitle('guide.cost') }}：</dt>
              <dd>{{ item.expenses }}</dd>
            </dl>
            <p v-if="item.tips">
              {{ getTitle('guide.tips') }}：{{ item.tips }}
            </p>
          </div>
        </li>
      </ul>
      <el-pagination
        v-if="guideList && guideList.length > 0"
        background
        layout="prev, pager, next"
        :page-count="pageAll"
        :current-page="current_page"
        @current-change="currentChange"
      >
      </el-pagination>
      <div class="list-none" v-if="guideList.length == 0">
        <p>{{ getTitle('content.noData') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import www from '@/api/www';
import _ from 'underscore';
import routerTo from '@/router/routerTo';
export default {
  components: {},
  data() {
    return {
      guideList: [],
      page: 1,
      pageAll: 0,
      current_page: 1,
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    // guideList2() {
    //   return this.localeGuideList(this.locale);
    // },
  },
  watch: {
    $route(to, from) {
      // console.log(to, from);
      if (to.fullPath !== from.fullPath) {
        this.page = 1;
        this.getGuideList(this.locale);
      }
    },
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    this.getGuideList(this.locale);
  },
  methods: {
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    async getGuideList(languageStr) {
      const getGuideList = await www.getGuideList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        status: 'publish',
        language: languageStr == 'zh-cmn-Hans' ? 'zh' : languageStr,
        page: this.page,
        page_size: 12,
      });
      this.guideList = getGuideList.data;
      this.pageAll = getGuideList.page_total; //Math.ceil(orderNumberTotal / 2);
      this.current_page = getGuideList.current_page;
    },
    // localeGuideList(locale) {
    //   return _.filter(this.guideList, (cur) => {
    //     return cur.country_code === (locale === 'zh-cmn-Hans' ? 'zh' : locale);
    //   });
    // },
    currentChange(value) {
      this.page = value;
      this.getGuideList(this.locale);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.guide-wrapper {
  width: 1100px;
  margin: 20px auto;
  .guide-tips {
    width: 1060px;
    margin: 0 auto 20px;
    padding: 30px 30px;
    border-radius: 10px;
    background: #f6fcf9;
  }
  .guide-list {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
    list-style: none;
    li {
      width: 340px;
      margin: 0 10px 20px;
      padding: 20px 20px;
      line-height: 24px;
      text-align: justify;
      background: #f6f9fc;
      .top {
        padding: 20px 0 20px;
        // border-bottom: 1px solid #dbe6e1;
        text-align: center;
        .avatar {
          width: 130px;
          height: 130px;
          margin: 0 auto;
          margin-bottom: 10px;
          border-radius: 65px;
          background-repeat: no-repeat;
          background-position: 50% 50%;
          background-size: cover;
        }
        h3 {
          margin-bottom: 6px;
          font-size: 16px;
        }
        .ranking {
          display: block;
          height: 25px;
          margin: 0 auto;
          margin-bottom: 10px;
          text-indent: -9999px;
          background-image: url(../../assets/images/icon-ranking.png);
          background-repeat: no-repeat;
          background-size: 125px 125px;
        }
        .ranking1 {
          width: 25px;
          background-position: 0 0;
        }
        .ranking2 {
          width: 50px;
          background-position: 0 -25px;
        }
        .ranking3 {
          width: 75px;
          background-position: 0 -50px;
        }
        .ranking4 {
          width: 100px;
          background-position: 0 -75px;
        }
        .ranking5 {
          width: 125px;
          background-position: 0 -100px;
        }
        .level {
          span {
            margin: 0 10px;
          }
        }
        .tel {
          display: inline-block;
          margin-top: 10px;
          padding: 8px 18px;
          border-radius: 18px;
          color: #fff;
          background: #31a775;
        }
      }
      .bottom {
        dt {
          float: left;
          width: 60px;
          color: #31a775;
        }
        dd {
          margin-left: 60px;
        }
        p {
          margin-top: 10px;
        }
      }
      .text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        line-height: 30px;
        h3 {
          color: #191b26;
          font-weight: normal;
          font-size: 24px;
          line-height: 32px;
        }
        p {
          color: #515457;
        }
      }
      .button {
        .btn {
          display: block;
          padding: 8px 38px;
          border: 1px solid #31a775;
          color: #31a775;
          font-weight: bold;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
    li:hover {
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.1);
    }
  }
  .el-pagination {
    padding: 40px 0 60px;
    text-align: center;
  }
  .list-none {
    padding: 40px 0;
    text-align: center;
  }
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #31a775;
}
</style>
